import { SlideOutBar } from './Components/SlideOutBar/SlideOutBar';
import { InfoBar } from './Components/InfoBar/InfoBar';
import './App.scss';
// import locations_json from './locations.json'

import { useEffect, useState } from 'react';
import Header from './Components/Header/Header'
import Map from './Components/Map/Map'

// const locations = locations_json.LOCATIONS.map((location)=>{
// 	return {
// 		date: location['DATE_OF_DAMAGE'],
// 		date_obj: new Date(location['DATE_OF_DAMAGE']),
// 		type: location['EVENT_TYPE '].toLowerCase().replace(" damage", ""),
// 		lat: parseFloat(location['LAT']),
// 		lng: parseFloat(location['LONG']),
// 		locate_requested: location['WAS-ONECALL_NOTIF '].toLowerCase(),
// 		exc_type: location['EXCAVATION_TYPE '],
// 		fac_damage: location['FAC_DAMAGED'],
// 		fac_affected: location['FAC_AFFECTED'],
// 	};
// });
const colors =[
	'#FF5C00',
	'#8BDA00',
	'#77BB00',
	'#DA5003',
	'#475B81',
	'#E0CA9F',
	'#717171',
	'#1EC5DC',
	'#FF5AEF',
];
// Pull out unique exc_types from locations array;

//console.table(locations[0]);

function App() {
	var date = new Date();
	var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);				
	const [locationData, setLocationData] = useState(null);
	const [currentLocation, setCurrentLocation] = useState(null);
	const [activeFilters, setActiveFilters] = useState({underground:true, overhead:true, locate_requested:false});
	const [activeDate, setActiveDate] = useState({start:firstDay, end:date});
	const [exc_types, setExctypes] = useState([]);	
	const [possibleYears, setPossibleYears] = useState([]);

	useEffect(() => {
		//fetch("api.php")
		fetch(`/wp-json/utility-safety/v1/incidents`)
		.then(response => response.json())		
		.then(data => updateLocationData(data))		
	}, []);

	const updateLocationData = (locations_json) => {
		//console.log(locations_json);
		const locations = locations_json.map((location)=>{

			return {
				date: location['DATE_OF_DAMAGE'],
				date_obj: new Date(location['DATE_OF_DAMAGE']),
				type: location['EVENT_TYPE'].toLowerCase().replace(" damage", ""),
				lat: parseFloat(location['LATITUDE']),
				lng: parseFloat(location['LONGITUDE']),
				locate_requested: (location['WAS_ONECALL_NOTIF']).trim().toLowerCase(),
				exc_type: location['EXCAVATION_TYPE'],
				fac_damage: location['FAC_DAMAGED'],
				fac_affected: location['FAC_AFFECTED'],
			};
		});
		//console.log(locations);
		setExctypes([...new Set(locations.map((item, i) => {return {label:item.exc_type, color:colors[i]}}))]);
		setLocationData(locations);
		let years =[...new Set(locations.map((item) => {return item.date_obj.getFullYear()}))];
		//sort years
		years.sort((a, b) => b - a);
		setPossibleYears(years);
		
	}
	//Get possible years from locations

	return (
    	<div className="App">
			{locationData ? 
				<>
					<Header possibleYears={possibleYears} activeFilters={activeFilters} setActiveFilters={setActiveFilters} setActiveDate={setActiveDate}></Header>
					<InfoBar exc_types={exc_types} locations={locationData} activeDate={activeDate} activeFilters={activeFilters} />
					<Map activeDate={activeDate} locations={locationData} activeFilters={activeFilters} currentLocation={currentLocation} setCurrentLocation={setCurrentLocation} ></Map>
					
					<SlideOutBar currentLocation={currentLocation} setCurrentLocation={setCurrentLocation}  />
				</>
			: <></>}
			
		</div>
	);
}

export default App;
